const ACCOUNT_STATUSES: { [key: string]: string } = {
  active: 'Активный',
  inactive: 'Не активный',
  suspended: 'Заблокирован',
  pending: 'Не активирован'
};

export { ACCOUNT_STATUSES };
